import React, { useState, useEffect } from "react";
import "../css/Publication.css";
import { Outlet, Link, useLocation } from "react-router-dom";
import ReviewCard from "../components/ReviewCard";
import ReviewCardCatalogue from "../components/ReviewCardCatalogue";
import { reviews } from "./data";
import LiteratureReview from "./literature-review";
import Catalogue from "./catalogue";
// import React from "react";

const Home = () => {
	// const location = useLocation();
	// const currentPath = location.pathname.split('/').pop()||LiteratureReview;
	// const [activeLink, setActiveLink] = useState(currentPath || "");
	const [currentIndex, setCurrentIndex] = useState(0);
	const [currentRender, setCurrentRender] = useState("LR");

	const publicationContentData = [
		{
			sidebarName: " Research Publication ",
			heading: "Literature Review",
			render: "LR"
		},
		{
			sidebarName: "Astro Photography Catalogue",
			heading: "Astro Photography Catalogue",
			render: "AC"
		}
	]

	const quotes = [
		{
			path: "literatureReview",
			text: "The literature review is the foundation of any worthwhile research project, providing the context and justification for the study's direction and significance."
		},
		{
			path: "catalogue",
			text: "An astrophotography catalogue is a scientific record and an invitation to wonder, preserving celestial moments while inspiring future discovery."
		}
	];

	// useEffect(() => {
	// 	setActiveLink(currentPath);
	// }, [currentPath]);

	// const handleClick = (linkName) => {
	// 	setActiveLink(linkName);
	// };
	// const activeQuote = quotes.find(q => q.path === activeLink)?.text || quotes[0].text;
	return (
		<div className="publication">
			<div className="publication_header-complete">
				<div>
					<div className="publication_waviy">
						<div className="publication_main-inner">
							<span className="publication_i1">O</span>
							<span className="publication_i2">U</span>
							<span className="publication_i3">R</span>
							<span className="publication_i4">&nbsp;</span>{" "}
							{/* Added space here */}
							<span className="publication_i5">P</span>
							<span className="publication_i6">U</span>
							<span className="publication_i7">B</span>
							<span className="publication_i8">L</span>
							<span className="publication_i10">I</span>
							<span className="publication_i11">C</span>
							<span className="publication_i12">A</span>
							<span className="publication_i13">T</span>
							<span className="publication_i14">I</span>
							<span className="publication_i15">O</span>
							<span className="publication_i16">N</span>
							<span className="publication_i17">S</span>
						</div>
					</div>
				</div>
			</div>
		
			<div className="publication-content">

				<div className="publication-sidebar">
					<div className="publication-sidebar-content">
					{publicationContentData.map((element, index) => {
						return (
						<div
							key={index}
							// className="publication-sidebar-element"
							className={`publication-sidebar-element ${
							currentIndex === index ? "active" : ""
							}`}
							onClick={() => {
							setCurrentIndex(index);
							setCurrentRender(element.render);
							}}
						>
							<h1>{element.sidebarName}</h1>
						</div>
						);
					})}
					</div>
				</div>

				<div className="publication-main">
					{/* <div className="publication-quote"> */}
						{/* <p>{quotes[currentIndex].text}</p> */}
					{/* </div> */}
					<div className="publication-header">
						{currentRender == "LR" && (<LiteratureReview/>)}
						{currentRender == "AC" && (<Catalogue/>)}
					</div>
					<div className="review_cards">
						{currentRender == "LR" && (reviews.map((review) => (
							<ReviewCard key={review.id} review={review} />
						)))}
						{currentRender == "AC" && (reviews.map((review) => (
							<ReviewCardCatalogue key={review.id} review={review} />
						)))}
					</div>
				</div>

			</div>















{/* 
				<div className="publication-wrapper">
					<div className="publication-buttons">
						<Link
							to="literatureReview"
							className={(activeLink === "literatureReview" ) ? "active-link" : "inactive-link"}
							onClick={() => handleClick("literatureReview")}
						>
							Literature Review
						</Link>
						<Link
							to="catalogue"
							className={activeLink === "catalogue" ? "active-link" : "inactive-link"}
							onClick={() => handleClick("catalogue")}
						>
							Astro Photography Catalogue
						</Link>
					</div>
					<div className="publication-display">
						{/* This is where nested components will render */}
						{/* <Outlet />

					</div>
				</div>  */}

				{/* <div className="chapters">
					{(activeLink === "literatureReview") && <div className="review_cards">
						{reviews.map((review) => (
							<ReviewCard key={review.id} review={review} />
						))}
					</div>}
					{activeLink === "catalogue" && <div className="review_cards">
						{reviews.map((review) => (
							<ReviewCardCatalogue key={review.id} review={review} />
						))}
					</div>}
				</div> */}
		</div>
	);
};

export default Home;
